import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useSWR from "swr";
import { TableSearchInput } from "components/common/input";
import { BurialListTable } from "components/burial";
import { PrimayPagination } from "components/common/pagination";
import { AddBtn } from "components/common/button";
import routerConstant from "service/constant/routerConstant";
import type { IBurialList } from "service/interface/burial";

export function BurialListPage() {
  const navigate = useNavigate();
  const [searchInput, setSearchInput] = useState<string>("");
  const [selectPage, setSelectPage] = useState<number>(1);
  const [listData, setListData] = useState<{
    count: number;
    data: IBurialList[];
  }>({
    count: 1,
    data: [],
  });

  const { data } = useSWR(
    `/admin/manage/park?limit=12&offset=${
      selectPage * 12 - 12
    }&search=${searchInput}`,
  );

  useEffect(() => {
    if (data) {
      setListData(data);
    }
  }, [data]);

  const handleAddBtn = () => {
    navigate(routerConstant.BURIAL.add);
  };

  return (
    <div className="h-full min-h-[100vh] w-[calc(100%-273px)] bg-[#fdfdfd]">
      <div className="mx-auto w-[1167px] p-[78px_80px_55px_64px]">
        <p className="m-0 mb-[8px] text-[16px] font-semibold leading-[20px] text-gray-4 opacity-[0.5]">
          메모리올 관리자 화면
        </p>
        <p className="m-0 text-[32px] font-medium leading-[40px] text-black">
          장지 정보
        </p>
        <div className="mb-[26px] mt-[16px] flex items-center justify-between">
          <TableSearchInput
            value={searchInput}
            setValue={setSearchInput}
            placeholder="키워드로 검색해 보세요."
          />
          <div className="flex items-center gap-[8px]">
            <AddBtn onClick={handleAddBtn} />
          </div>
        </div>
        <BurialListTable data={listData.data} />
        <div className="mt-[32px] flex items-center justify-end">
          <PrimayPagination
            listLength={Math.ceil(listData.count / 12)}
            pageNumber={selectPage}
            setPageNumber={setSelectPage}
          />
        </div>
      </div>
    </div>
  );
}
